import httpClient from "@plugins/http";

export default {
  fetchLessonStatusHistory: (params) =>
    httpClient.get(`/apis/status-history/lesson/${params.resourceDomain}/${params.uuid}`),

  fetchMediaStatusHistory: (uuid) => httpClient.get(`/apis/status-history/mediaobject/${uuid}`),
};
